import { useEffect, useState } from 'react';

/**
 * Passe à vrai une fois le délai écoulé sans que `active` soit retombé.
 * Sert de filet aux tunnels de chargement : un écran d'attente finit toujours par céder la place
 * à un état terminal, même si aucune requête ne se termine ni n'échoue.
 *
 * Suppose que `active` ne repasse pas de faux à vrai sur une même instance : le drapeau interne
 * n'est pas remis à zéro, une réactivation renverrait donc vrai immédiatement. C'est le cas des
 * deux tunnels d'entrée du live, dont l'état de chargement est terminal une fois résolu.
 */
export function useElapsedFlag(delayMs: number, active: boolean): boolean {
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    if (!active) return;
    const timer = window.setTimeout(() => setElapsed(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [delayMs, active]);

  return active && elapsed;
}
